
import { Loader, Center, Text } from '@mantine/core';

const Error = () => {

  return (
    <Center style={{ flexDirection: 'column', minHeight: '100vh' }}>
      <Text size="xl" style={{ marginBottom: '20px', color: '#FF0000' }}>
        <h2>Payment Failed / Cancelled</h2>
      </Text>
      <Loader size="xl" />
      <Text size="lg" style={{ marginTop: '20px' }}>
        Something went wrong with your payment. Please try again.
      </Text>
    </Center>
  );
};

export default Error;
